<template>
  <v-snackbar v-model="dialog" :color="color">
    <strong>
      {{ message }}
    </strong>
    <template v-slot:action="{ attrs }">
      <v-btn color="white" icon v-bind="attrs" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import AlertModal from "./index";
export default {
  data() {
    return {
      message: "",
      dialog: false,
      color: 'primary',
    };
  },
  methods: {
    show(message) {
      const vm = this;
      vm.message = message.message ? message.message : message;
      vm.color = message.color ? message.color : "primary";
      vm.dialog = true;
    },
  },
  beforeMount() {
    AlertModal.EventBus.$on("show", (params) => {
      this.show(params);
      if(params?.color) {
        this.color = params.color;
      }
    });
    AlertModal.EventBus.$on("hide", () => {
      this.dialog = false;
    });
  },
};
</script>

<style></style>
